import AsyncSelect from 'react-select/async';
import CreatableAsyncSelect from 'react-select/async-creatable';
import { Box, FormHelperText, useTheme } from '@mui/material';
import { forwardRef } from 'react';
import { Controller } from 'react-hook-form';
import { observer } from 'mobx-react';

const AutoComplete = forwardRef(
  (
    {
      name,
      control,
      error = false,
      helperText = '',
      defaultOptions,
      loadOptions,
      overwriteProps = {},
      creatable = false,
      isMulti = false,
      inPopUp = false,
      onChangeOther = () => undefined,
      showDropDown = true,
      placeholder,
      ...props
    },
    ref,
  ) => {
    const theme = useTheme();
    const SelectComponent = creatable ? CreatableAsyncSelect : AsyncSelect;

    const getBorderColor = (fsError, state) => {
      if (fsError?.message) {
        return theme.palette.error.main;
      }
      if (state.isFocused) {
        return theme.palette.primary.main;
      }
      return theme.palette.grey[400];
    };

    return (
      <Box>
        <Controller
          control={control}
          name={name}
          render={({ field, fieldState: { error: fsError } }) => {
            return (
              <SelectComponent
                {...field}
                {...props}
                {...(!showDropDown
                  ? {
                      components: {
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                      },
                    }
                  : {})}
                isMulti={isMulti}
                value={field?.value?.label === '' ? null : (field?.value ?? '')}
                error={Boolean(fsError?.message)}
                helperText={fsError?.message || helperText || ''}
                ref={ref}
                defaultOptions={defaultOptions}
                loadOptions={loadOptions}
                placeholder={
                  placeholder
                    ? `${placeholder} (type to search)`
                    : 'Type to search'
                }
                onChange={option => {
                  field.onChange(option);
                  if (onChangeOther) {
                    onChangeOther(option, field?.value);
                  }
                }}
                menuPortalTarget={document.body}
                styles={{
                  control: (baseStyles, state) => {
                    return {
                      ...baseStyles,
                      borderColor: getBorderColor(fsError, state),
                      borderRadius: theme.shape.borderRadius,
                      '&:hover': { borderColor: theme.palette.common.black },
                      marginTop: '-4px',
                    };
                  },

                  ...(inPopUp && {
                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                  }),
                }}
                {...overwriteProps}
              />
            );
          }}
        />
        {error || helperText ? (
          <FormHelperText sx={{ typography: 'body2' }} error={Boolean(error)}>
            {error || helperText}
          </FormHelperText>
        ) : null}
      </Box>
    );
  },
);

export default observer(AutoComplete);
